import { useQuery } from '@tanstack/react-query';
import { propertiesApi } from 'API/properties-api/properties-api';
import { ComparisonDates } from 'types/properties-data';
import { DEFAULT_QUERY_STALE_TIME } from 'queries/constant';
import { salesMetricsQueryKeys } from 'hooks/queries/properties/property-keys';

type GetAccountPropertiesQueryProps = {
    accountPropertiesTagId?: string;
    dates?: ComparisonDates;
    enabled?: boolean;
};

export const useGetSalesMetricsByTagIdQuery = ({
    enabled = true,
    accountPropertiesTagId,
    dates,
}: GetAccountPropertiesQueryProps = {}) => {
    return useQuery({
        queryKey: salesMetricsQueryKeys.filters({ tagId: accountPropertiesTagId, dates }),
        enabled: enabled && !!accountPropertiesTagId && !!dates,
        staleTime: DEFAULT_QUERY_STALE_TIME,
        refetchOnMount: false,
        refetchOnWindowFocus: false,
        queryFn: async () => propertiesApi.getSalesMetricsByTagId(accountPropertiesTagId, dates!),
    });
};
